import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/bands";

class BandDashboardService {
  // ===============================
  // Band Analytics
  // ===============================

  getBandAnalytics = async (bandId) => {
    try {
      const { data } = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/analytics`,
      );
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band analytics.");
    }
  };

  getBandProductAnalytics = async (bandId, limit = 10) => {
    try {
      const { data } = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/product-analytics`,
        { params: { limit } },
      );
      return data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching band product analytics.",
      );
    }
  };

  // ===============================
  // Band Products
  // ===============================

  getBandProducts = async (bandId, params = {}) => {
    try {
      // FE-B: backend vraća ravan body { data, total, page, perPage, ... }.
      // Ranije se `pagination` destrukturirao sa axios objekta (uvek undefined),
      // a ceo body se vraćao kao `data` → lista nije bila niz.
      const { data } = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/products`,
        { params },
      );
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band products.");
    }
  };

  // ===============================
  // Band Orders
  // ===============================

  getBandOrders = async (bandId, params = {}) => {
    try {
      const { data } = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/orders`,
        { params },
      );
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching band orders.");
    }
  };

  // ===============================
  // Band Monthly Revenues
  // ===============================

  getBandMonthlyRevenues = async (bandId) => {
    try {
      const { data } = await axiosApiClient.get(
        `${BASE_URL}/${bandId}/revenue/monthly`,
      );
      return data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching band monthly revenues.",
      );
    }
  };

  getMonthlyBandRevenuesByPeriod = async ({
    bandId,
    startYear,
    startMonth,
    endYear,
    endMonth,
  }) => {
    try {
      const { data } = await axiosApiClient.get(
        `/revenue/${bandId}/revenue/monthly/period`,
        {
          params: {
            startYear,
            startMonth,
            endYear,
            endMonth,
          },
        },
      );

      return data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching monthly band revenues by period.",
      );
    }
  };
}

const bandDashboardService = new BandDashboardService();
export default bandDashboardService;
